import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Section from '../components/Section.jsx';
import { steps } from '../content.js';

export default function HowItWorks() {
  return (
    <Section
      id="como-funciona"
      eyebrow="Como funciona"
      title="Do grupo de WhatsApp para uma vitrine organizada"
      subtitle="Quatro etapas, sem pedir que ninguém mude de hábito."
    >
      <Grid container spacing={3}>
        {steps.map((step) => (
          <Grid key={step.number} size={{ xs: 12, sm: 6, md: 3 }}>
            <Card elevation={0} sx={{ height: '100%' }}>
              <CardContent sx={{ p: 3 }}>
                <Typography
                  variant="h4"
                  component="span"
                  sx={{ color: 'secondary.main', display: 'block', mb: 1.5 }}
                >
                  {step.number}
                </Typography>
                <Typography variant="h6" component="h3" gutterBottom>
                  {step.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {step.text}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Section>
  );
}
